export function clearOrderSuccessStorage() {
  localStorage?.removeItem("cart");
  localStorage?.removeItem("scheduleData");
  localStorage?.removeItem("selectedOrderStatus");
}
